import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import MessageBodyIsForm from './MessageBodyIsForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(MessageBodyIsForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/MessageBodyIs/MessageBodyIsForm.container.js